import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import AddSiteMain from '../../components/sites/AddSiteMain'
import Footer from '../../components/common/Footer'
export default function SiteAddPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <AddSiteMain />
            <Footer/>
        </>
    )
}
